export default {
  fields: {
    price: 'Precio',
    tax: 'Impuesto',
    visible_to: 'Visible para',
  },
  buttons: {
    add_price: '+ Agregar precio',
  },
};
